import api from './api';

export const inviteService = {
  createInvite: async (data) => {
    const response = await api.post('/invites', data);
    return response.data;
  },

  getAllInvites: async () => {
    const response = await api.get('/invites');
    return response.data;
  },

  deleteInvite: async (id) => {
    const response = await api.delete(`/invites/${id}`);
    return response.data;
  },

  validateInvite: async (code) => {
    const response = await api.post('/invites/validate', { code });
    return response.data;
  }
};
